import React from 'react';
import theme from 'shared/constants/theme.json';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const InputInfoCircle = ({ icon, iconStyle, ...rest }) => {
  const tooltipIcon = icon || <InfoCircleOutlined style={{ color: theme['text-color-secondary'], ...iconStyle }} />;

  return <Tooltip {...rest}>{tooltipIcon}</Tooltip>;
};

export default InputInfoCircle;
